import { WebSocketConnection } from '../webSocket/webSocketConnection';
/**
 * Class to manage websocket list of app
 */
export class WebSocketManager {
    /**
     * List of socket connection
     * @type {IWebSocketConnection[]}
     */
    get sockets() {
        var _a;
        return (_a = window === null || window === void 0 ? void 0 : window.sockets) !== null && _a !== void 0 ? _a : {};
    }
    /**
     * Set list of socket connection
     */
    set sockets(value) {
        window.sockets = value;
    }
    /**
     * Remove socket for the socket list
     * @param socketId Socket Id to remove
     */
    removeSocket(socketId) {
        this.sockets[socketId].close();
        delete this.sockets[socketId];
    }
    /**
     * Add socket to the socket list
     * @param socketId
     */
    addSocket(socketId) {
        if (Object.keys(this.sockets).includes(socketId))
            return;
        const socket = new WebSocket(socketId);
        this.sockets = {
            ...this.sockets,
            [socketId]: new WebSocketConnection(socket, {
                log: (message) => {
                    var _a;
                    const showLogs = (_a = process.env.REACT_APP_SHOW_LOGS) !== null && _a !== void 0 ? _a : true;
                    if (showLogs === 'true') {
                    }
                }
            })
        };
    }
    /**
     * Get socket from the socket list
     * @param socketId Socket id for find
     * @returns Socket - IWebSocketConnection
     */
    getSocket(socketId) {
        return this.sockets[socketId];
    }
    /**
     * Get list of all id socket from the socket list
     * @returns list of socket id - String[]
     */
    getSocketIds() {
        return Object.keys(this.sockets);
    }
    /**
     * Get count of socket in the list
     * @returns Count of socket in the list - number
     */
    getSocketCount() {
        return this.getSocketIds().length;
    }
}
